import styled from "styled-components";

export const PaginationContainer = styled.ul`
  display: grid;
  grid-auto-rows: 45px;
  grid-auto-columns: 45px;
  grid-auto-flow: column;
  gap: 4px;
`;
